// extracted by mini-css-extract-plugin
export var RichText = "M_cd";
export var aniBgLoading = "M_f";
export var aniSpin = "M_d";
export var headingStyles = "M_cg";
export var imageStyles = "M_ch";
export var listStyles = "M_cf";
export var tableStyles = "M_cj";